import { RouteRecordRaw } from 'vue-router';

// Ленивая загрузка компонентов
const CanvasPage = () => import('../pages/canvas/canvas-page.vue');
const SettingsPage = () => import('../pages/settings-page/settings-page.vue');
const ApiPage = () => import('../pages/api-page/api-page.vue');
const ApiCompareVersionPage = () => import('../pages/api-page/api-compare-version-page.vue');
const ApiCompareMethodPage = () => import('../pages/api-page/api-compare-method-page.vue');
// const ApiViewMethodPage = () => import('../pages/api-page/api-view-method-page.vue');
const WikiPage = () => import('../pages/wiki/wiki-page.vue');

export interface RouteMeta {
  title: string;
  isAuth: boolean;
  roles: string[];
}

const defaultMeta: RouteMeta = {
  isAuth: true,
  roles: [],
  title: '',
};

/** Маршруты проекта */
const WikiRoutes: RouteRecordRaw[] = [
  {
    name: 'wiki-project',
    path: 'project/:id', // Маршрут по умолчанию для проекта
    component: WikiPage,
    meta: {
      title: 'Wiki',
      ...defaultMeta,
    },
  },

  {
    name: 'wiki-folder',
    path: 'project/:id/:folderId', // Маршрут по умолчанию для проекта
    component: WikiPage,
    meta: {
      title: 'Wiki',
      ...defaultMeta,
    },
  },
  {
    name: 'wiki-detail',
    path: 'project/:id/page/:wikiId', // :wikiId — идентификатор вики
    component: CanvasPage,
    meta: {
      title: 'Wiki детальная',
      ...defaultMeta,
    },
  },
  {
    name: 'wiki-api',
    path: 'project/:id/api', // API проекта
    component: ApiPage,
    meta: {
      title: 'API проекта',
      ...defaultMeta,
    },
  },
  {
    name: 'wiki-api-compare-version',
    path: 'project/:id/api-compare/', // Маршрут по умолчанию для проекта
    component: ApiCompareVersionPage,
    meta: {
      title: 'Сравнение версий API микросервиса',
      ...defaultMeta,
    },
  },
  // {
  //   name: 'api-view-method',
  //   path: 'project/:id/api-view/:methodId', // Маршрут по умолчанию для проекта
  //   component: ApiViewMethodPage,
  //   meta: {
  //     title: 'Просмотр метода API микросервиса',
  //     ...defaultMeta,
  //   },
  // },
  {
    name: 'api-compare-method',
    path: 'project/:id/api-compare/', // Маршрут по умолчанию для проекта
    component: ApiCompareMethodPage,
    meta: {
      title: 'Сравнение версий метода API микросервиса',
      ...defaultMeta,
    },
  },
  {
    name: 'wiki-settings',
    path: 'project/:id/settings', // Настройки проекта
    component: SettingsPage,
    meta: {
      title: 'Настройки проекта',
      ...defaultMeta,
    },
  },
];

export default WikiRoutes;
